module.exports = __webpack_public_path__ + "static/CareLabel-v1-8889d03f28b09de426e1781b1738a249.svg";